var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbImageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85386 6.14651C8.04911 6.34176 8.04911 6.65836 7.85386 6.85361L5.0254 9.68206C4.83016 9.87731 4.51359 9.87731 4.31832 9.68206C4.12306 9.48676 4.12306 9.17021 4.31832 8.97491L6.79321 6.50006L4.31832 4.02518C4.12306 3.82992 4.12306 3.51334 4.31832 3.31808C4.51359 3.12281 4.83016 3.12281 5.0254 3.31808L7.85386 6.14651Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbImageArrow);
export default __webpack_public_path__ + "static/media/breadcrumb-image-arrow.267ac3fc7b24c930ea99e0a246299a44.svg";
export { ForwardRef as ReactComponent };